// extracted by css-extract-rspack-plugin
export default {"Container":"LphA8","HeaderContainer":"rW65e","HeaderName":"AzaCX"};